export const ERROR = {
  ACCOUNT_ALREADY_IN_USE: 'الحساب مستخدم الرجاء ادخال حساب اخر',
  INVALID_VERIFICATION_CODE: 'الرمز غير صحيح ',
  INVALID_ACCOUNT_TYPE: 'الحساب المدخل غير صحيح',
  // USER_LIMIT: 'USER_LIMIT'
  USER_NOT_FOUND: 'لا يوجد هكذا مستخدم',
  // INVALID_LOGIN: ''
  INVALID_SEARCH_DATA: 'البيانات المدخلة غير صحيحة',
  PERMISSION_DENIED: 'غير مسموح إجراء تلك العملية',
  ACCOUNT_NOT_FOUND: 'لا يوجد هكذا حساب',
  ANNOUNCEMENT_NOT_FOUND: 'Attachment NOT found',
  INVALID_TOKEN: 'فشل التعرف، الرجاء تسجيل الدخول مرة أخرى',
  ALREADY_IN_GROUP: 'أنت منضم أصلا في هذه المجموعة',
  BLOCKED_FROM_CONV: 'أنت محظور من دخول هذه المجموعة',
  GROUP_NOT_FOUND: 'لا توجد مجموعة بهذا الرمز',
  INVALID_MATERIAL_TYPE: 'لا يمكن رفع هكذا نوع من الملفات',
  LAST_ACCOUNT_REMOVE: 'لا يمكنك حذف آخر حساب مسجل',
  SERVER_NOT_WORKING: 'لم نستطيع الإتصال بالخادم، الرجاء التأكد من اتصال الإنترنت والمحاولة مرة اخرى'
};



// WEBPACK FOOTER //
// ./src/lang/ar/error.js